<template>
  <div class="bottombody" >
    <el-divider content-position="left">官网底部分类管理</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入分类名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.category_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="标题" prop="nav">
            <el-input v-model="categoryForm.nav" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="分类" prop="categoryId">
            <div style="display: flex; flex-direction: row">
              <div style="margin-right: 0.2rem; width: 100%">
                <el-cascader
                  clearable
                  filterable
                  v-model="categoryForm.categoryId"
                  :options="options"
                  :props="{
                    expandTrigger: 'hover',
                    label: 'category_name',
                    value: 'id',
                    checkStrictly: true,
                  }"
                  @click.native="loadCategory"
                  size="mini"
                  style="width: 100%"
                  ref="cascader"
                ></el-cascader>
                <!-- @change="handleChangeCascader" -->
              </div>
              <div>
                <el-popover
                  placement="bottom"
                  width="500"
                  trigger="click"
                  @hide="clearSelf"
                >
                  <el-form
                    :model="addAddressForm"
                    :rules="rules"
                    ref="addAddressForm"
                    label-width="80px"
                  >
                    <el-form-item label="分类名称" prop="category_name">
                      <el-input
                        v-model="addAddressForm.category_name"
                        size="mini"
                        placeholder="请输入分类名称"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="链接地址" prop="url">
                      <el-input
                        v-model.trim="addAddressForm.url"
                        size="mini"
                        placeholder="请输入链接地址"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="图标" prop="icon">
                      <el-input
                        v-model.trim="addAddressForm.icon"
                        size="mini"
                        placeholder="请输入图标"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="是否显示" prop="display">
                      是
                      <el-switch
                        v-model="addAddressForm.display"
                        active-color="#ff4949"
                        inactive-color="#13ce66"
                      >
                      </el-switch>
                      否
                    </el-form-item>
                    <el-form-item label="是否弹窗" prop="alert">
                      是
                      <el-switch
                        v-model="addAddressForm.alert"
                        active-color="#ff4949"
                        inactive-color="#13ce66"
                      >
                      </el-switch>
                      否
                    </el-form-item>
                  </el-form>
                  <div style="margin-top: 0.15rem; text-align: right">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="saveChange('addAddressForm')"
                      >保存</el-button
                    >
                  </div>
                  <el-button type="primary" size="mini" slot="reference"
                    >添加分类
                  </el-button>
                </el-popover>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="链接地址" prop="url">
            <el-input v-model="categoryForm.url" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="icon">
            <el-input v-model="categoryForm.icon" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="categoryForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <el-form-item label="是否弹窗" prop="alert">
            是
            <el-switch
              v-model="categoryForm.alert"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editCategoryForm"
          :rules="rules"
          ref="editCategoryForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="categoryId">
            <el-input
              v-model="editCategoryForm.categoryId"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="链接地址" prop="url">
            <el-input v-model="editCategoryForm.url" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="icon">
            <el-input v-model="editCategoryForm.icon" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="ifDisplay"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <el-form-item label="是否弹窗" prop="alert">
            是
            <el-switch
              v-model="ifAlert"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editCategoryForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
      ref="categoryData"
      max-height="650"
      :data="categoryData"
      style="width: 100%; margin-top: 10px"
      row-key="id"
      @expand-change="change"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
      @row-click="device_detail"
    >
      <!-- <el-table-column prop="id" label="ID"> </el-table-column> -->
      <el-table-column prop="category_name" label="分类名称"> </el-table-column>
      <el-table-column prop="url" label="链接地址"> </el-table-column>
      <el-table-column prop="icon" label="图标"> </el-table-column>
      <el-table-column prop="display" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadioC(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column prop="alert" label="是否弹窗">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfAlert[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListAlertC(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSortC(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, categoryData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'OfficialBottom',
  data () {
    var categoryId = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    return {

      addAddressForm: {
        category_name: '',
        url: '',
        icon: '',
        display: false,
        alert: true
      },
      searchArr: {
        category_id: ''
      },
      loadC: [],
      npage: 1,
      needRow: '',
      categoryPerPage: 10,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ifAlert: false,
      ListIfDisplay: [],
      ListIfAlert: [],
      listSort: [],
      options: [],
      category: '',
      editId: '',
      categoryForm: {
        nav: '',
        categoryId: '',
        category_name: '',
        display: false,
        url: '',
        icon: '',
        alert: true
      },
      editCategoryForm: {
        nav: '',
        categoryId: '',
        category_name: '',
        display: false,
        url: '',
        icon: ''
      },
      rules: {
        categoryId: [
          {
            validator: categoryId,
            trigger: 'blur'
          },
          { required: true, message: '请输入分类', trigger: 'blur' }
        ],
        nav: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        category_name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { max: 100, message: '分类名不超过100字符', trigger: 'blur' }
        ],
        url: [{ max: 200, message: '链接地址不超过200字符', trigger: 'blur' }],
        icon: [{ max: 100, message: '图标不超过200字符', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.loadTable()
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    'categoryForm.categoryId': {
      handler () {
        if (this.$refs.cascader) {
          this.$refs.cascader.dropDownVisible = false
        }
      }
    }
  },
  methods: {
    loadTable () {
      this.$axios
        .get('api/official_bottom/index', {
          params: {
            // page: this.npage,
            // perpage: this.categoryPerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            // this.categoryData = data.data
            // this.total = data.data.total
            this.loadRadio()
            this.loadRadioAlert()
            this.loadSort()
          }
        })
        .catch()
    },
    loadRadio () {
      if (!this.categoryData) return false
      this.categoryData.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadRadioAlert () {
      if (!this.categoryData) return false
      this.categoryData.map(item => {
        if (item.alert === 1) {
          this.ListIfAlert[item.id] = false
        } else {
          this.ListIfAlert[item.id] = true
        }
      })
    },
    loadSort () {
      if (!this.categoryData) return false
      this.categoryData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      // this.needRow = index
      setTimeout(() => {
        if (!this.editId) return false
        this.$axios
          .get('api/official_bottom/show', {
            // params: {
            //   id: data[index].id
            // }
            params: {
              id: this.editId
            }
          })
          .then(({ data }) => {
            if (data.code === 1) {
              if (data.data.display === 1) {
                this.ifDisplay = false
              } else {
                this.ifDisplay = true
              }
              data.data.alert === 1
                ? (this.ifAlert = false)
                : (this.ifAlert = true)
              this.editCategoryForm.categoryId = data.data.category_name
              this.editCategoryForm.url = data.data.url
              this.editCategoryForm.icon = data.data.icon
              this.category = data.data.id
            }
          })
          .catch()
        this.categoryEditDrawer = true
      })
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/official_bottom/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      this.npage = 1
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/official_bottom/store', {
              category_name: this.categoryForm.nav,
              parents: this.categoryForm.categoryId,
              // pid: this.categoryForm.categoryId.pop(),
              url: this.categoryForm.url,
              icon: this.categoryForm.icon,
              display: this.categoryForm.display === false ? 1 : 0,
              alert: this.categoryForm.alert === false ? 1 : 0
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryIndrawer = false
                this.resetForm('categoryForm')
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm (formName) {
      setTimeout(() => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$axios
              .put('api/official_bottom/edit', {
                // id: this.category,
                id: this.editId,
                category_name: this.editCategoryForm.categoryId,
                url: this.editCategoryForm.url,
                icon: this.editCategoryForm.icon,
                display: this.ifDisplay === false ? 1 : 0,
                alert: this.ifAlert === false ? 1 : 0
              })
              .then(res => {
                const { data } = res
                if (data.code === 1) {
                  this.$message.success(data.msg)
                  this.categoryEditDrawer = false
                  this.loadTable()
                  this.toggleRowExpansion_forAll(this.categoryData, false)
                  // if (this.loadC.length > 0) {
                  //   this.loadAll(this.loadC)
                  // }
                  // setTimeout(() => {
                  //   this.$refs.categoryData.toggleRowExpansion(this.needRow, false)
                  // })
                } else {
                  this.$message.error(data.msg)
                }
              })
              .catch()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      })
    },
    editListRadio (row) {
      this.$axios
        .put('api/official_bottom/listshow', {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editListRadioC (row) {
      setTimeout(() => {
        this.$axios
          .put('api/official_bottom/listshow', {
            id: this.editId,
            display: this.ListIfDisplay[row.id] === false ? 1 : 0
          })
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    editListAlert (row) {
      this.$axios
        .put('api/official_bottom/listshow_alert', {
          id: row.id,
          alert: this.ListIfAlert[row.id] === false ? 1 : 0
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editListAlertC (row) {
      setTimeout(() => {
        this.$axios
          .put('api/official_bottom/listshow_alert', {
            id: this.editId,
            alert: this.ListIfAlert[row.id] === false ? 1 : 0
          })
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/official_bottom/setsort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    setSortC (row) {
      setTimeout(() => {
        if (isNaN(this.listSort[row.id])) {
          this.$message.error('排序值为数字！')
          return false
        }
        this.$axios
          .put('api/official_bottom/setsort', {
            id: this.editId,
            sort: this.listSort[row.id]
          })
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    saveChange (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addAddressForm.display =
          this.addAddressForm.display === false ? 1 : 0
          this.addAddressForm.alert = this.addAddressForm.alert === false ? 1 : 0
          this.$axios
            .post('api/official_bottom/store_cate', this.addAddressForm)
            .then(({ data }) => {
              if (data.code === 1) {
                var myEvent = new Event('click')
                document.dispatchEvent(myEvent)
                this.$message.success(data.msg)
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        }
      })
    },
    clearSelf () {
      this.resetForm('addAddressForm')
    },
    loadCategory () {
      this.$axios
        .get('api/official_bottom/get_cate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.options = data.data
          }
        })
        .catch()
    },
    device_detail (val) {
      // this.needRow = val
      this.editId = val.id
    },
    loadRadioC (c) {
      c.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadRadioAlertC (c) {
      c.map(item => {
        if (item.alert === 1) {
          this.ListIfAlert[item.id] = false
        } else {
          this.ListIfAlert[item.id] = true
        }
      })
    },
    loadSortC (c) {
      c.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    change (v1, v2) {
      if (v2) {
        this.loadC = v1.children
        var cChildren = v1.children
        this.loadRadioC(cChildren)
        this.loadRadioAlertC(cChildren)
        this.loadSortC(cChildren)
      } else {
        this.loadC = []
        this.cChildren = []
      }
    },
    loadAll (c) {
      this.loadRadioC(c)
      this.loadRadioAlertC(c)
    },
    toggleRowExpansion_forAll (data, isExpansion) {
      data.forEach(item => {
        this.$refs.categoryData.toggleRowExpansion(item, isExpansion)
        if (item.children !== undefined && item.children !== null) {
          this.toggleRowExpansion_forAll(item.children, isExpansion)
        }
      })
    }
  }
}
</script>

<style  scoped>
.bottombody {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/official_bottom/bottom_body.vue